module.exports = __webpack_public_path__ + "static/demo_next.4bc467f3.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/demo_next.mp4
// module id = 1094
// module chunks = 35783957827783